import styled, { css } from "styled-components"
import { fontFamily, fontWeight, fontSize } from "buoy-theme"

const Link = styled.a`
  text-decoration: underline;
  font-family: ${fontFamily};
  font-weight: ${fontWeight.light};
  color: ${props => props.theme.colors[props.color]};
  ${props => fontSize(props.size)};
  ${props => props.margin && `margin: ${props.margin}`};
  ${props => props.block && "display: block;"}; 
  cursor: pointer;
  ${props =>
    props.ginaModal &&
    props.showCovid19AlertBanner &&
    css`
      @media (max-width: 380px) {
        font-size: 11px;
      }
    `}
`

Link.defaultProps = {
  color: "primary",
  size: "bodySmall",
}

export { Link as default }



// WEBPACK FOOTER //
// ./assets/common/components/Link.js